<template>
	<div class="highlighted-block-card-no-image gap-3 d-flex flex-column flex-md-row align-items-center px-5 py-4"
		 :style="{
				backgroundColor: data.section_background_color,
			 }"
	>
		<div class="col-10">
			<h2
					class="font-weight-bold"
					:style="{
							color: data.title_color,
						}"
			>
				{{ data.title }}
			</h2>
		</div>
		<div class="col-12 col-md-2">
			<a v-if="this.data?.button?.url?.includes('http')" :href="data.button.url" target="_blank">
				<button-unit
						class="float-end"
						:options="{
							text: data.button.title,
							type: 'button',
							shape: ButtonUnitShape.ROUNDED,
							textColor: data.button.color,
							bgColor: data.button.background,
					}"
				/>
			</a>
			<router-link v-else :to="{path: this.data?.button?.url}">
				<button-unit
						class="float-end"
						:options="{
							text: data.button.title,
							type: 'button',
							shape: ButtonUnitShape.ROUNDED,
							textColor: data.button.color,
							bgColor: data.button.background,
					}"
				/>
			</router-link>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {HighlightedBlockComponentClass, HighlightedBlockComponentInterface} from "../../Views/PageView/Interfaces/Components/HighlightedBlockComponentInterface";
import ButtonUnit from "../Units/ButtonUnit.vue";
import {ButtonUnitShape} from "../Units/Interfaces/ButtonUnitShape";

export default defineComponent({
	name: "HighlightedBlockCardNoImage",
	components: {ButtonUnit},
	computed: {
		ButtonUnitShape() {
			return ButtonUnitShape
		}
	},
	props: {
		data: {
			type: Object as PropType<HighlightedBlockComponentInterface>,
			default: new HighlightedBlockComponentClass(),
			required: true,
		}
	},
})
</script>

<style scoped>

</style>
